import { useQuery } from "@tanstack/react-query";

import { getDocument } from "@/api/documents";

export function useDocumentDetail(id: string | undefined) {
  return useQuery({
    queryKey: ["document", id],
    queryFn: () => getDocument(id as string),
    enabled: typeof id === "string" && id.length > 0,
  });
}
